import React from 'react';

const avatarContainerStyles = {
  position: 'absolute',
  zIndex: 1,
  bottom: '2px',
  left: `calc(100% - 42px)`,
  zoom: 0.5,
};

// eslint-disable-next-line react/prop-types
const CollabAvatarWrapper = ({ children }) => (
  <div style={avatarContainerStyles}>{children}</div>
);

export default CollabAvatarWrapper;
